<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">Download {{ data.type }}</h5>
    <button
      type="button"
      class="close"
      (click)="onCancelClick()"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form
    class="my-4 p-4"
    (ngSubmit)="onSubmit()"
    style="max-width: 400px; margin: auto">
    <div class="mb-3">
      <label for="language" class="form-label">Language</label>

      <mat-radio-group
        name="language"
        [(ngModel)]="formData.language"
        color="primary"
        class="d-flex align-items-center">
        <mat-radio-button class="mr-3" [value]="language.English">
          English
        </mat-radio-button>

        <mat-radio-button [value]="language.Arabic"> Arabic </mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="form-check mb-3 d-flex align-items-center label-justify">
      <label class="" for="isDeadHead">Include Dead Head</label>
      <input
        type="checkbox"
        class="form-check-input"
        id="isDeadHead"
        name="isDeadHead"
        [(ngModel)]="formData.isDeadHead" />
    </div>

    <div class="form-check mb-3 d-flex align-items-center label-justify">
      <label class="" for="isChecked">Include Flight Time</label>
      <input
        type="checkbox"
        class="form-check-input"
        id="isChecked"
        name="isChecked"
        [(ngModel)]="formData.isChecked" />
    </div>

    <div class="form-check mb-3 d-flex align-items-center label-justify">
      <label class="" for="isLayoverTime">Include Layover Time</label>
      <input
        type="checkbox"
        class="form-check-input"
        id="isLayoverTime"
        name="isLayoverTime"
        [(ngModel)]="formData.isLayoverTime" />
    </div>
    <div class="form-check mb-3 d-flex align-items-center label-justify">
      <label for="isWaitingTime">Include Waiting Time</label>
      <input
        type="checkbox"
        class="form-check-input"
        id="isWaitingTime"
        name="isWaitingTime"
        [(ngModel)]="formData.isWaitingTime" />
    </div>

    <button type="submit" class="btn btn-primary mt-3">Submit</button>
  </form>

  <!-- Additional modal sections (e.g., footer) if needed -->
</div>
